<template>
  <div>
    <b-card title="Hesap Bilgileri">
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <user-name />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <user-email />
        </b-col>
        <b-col
          cols="12"
          md="6"
        ><user-type /></b-col>
        <b-col
          cols="12"
          md="6"
        ><user-status /></b-col>
      </b-row>
    </b-card>
    <b-card title="Şube Ayaları">
      <b-row>
        <b-col cols="12">
          <branch-select />
        </b-col>
        <b-col cols="12">
          <user-branches />
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Hesap Güvenlik">
      <user-password />
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import UserName from '@/views/Users/elements/UserName.vue'
import UserEmail from '@/views/Users/elements/UserEmail.vue'
import UserPassword from '@/views/Users/elements/UserPassword.vue'
import UserType from '@/views/Users/elements/UserType.vue'
import UserStatus from '@/views/Users/elements/UserStatus.vue'
import BranchSelect from '@/views/Users/elements/BranchSelect.vue'
import UserBranches from '@/views/Users/elements/UserBranches.vue'

export default {
  name: 'UserForm',
  components: {
    BCard,
    BRow,
    BCol,
    UserName,
    UserEmail,
    UserPassword,
    UserType,
    UserStatus,
    BranchSelect,
    UserBranches,
  },
}
</script>
